import { useParams } from "react-router";

import CustomLoader from "@/components/CustomLoader/customLoader.component";
import { ROUTE_LOGIN_OUT } from "@/constants/routes.constants";
import { JWT } from "@/types";
import { clearAllLocFor } from "@/utils/localForageUtils";
import {
  isTokenExpired,
  refreshTokenCheckRedirect,
  requestAndSetTokens,
} from "@/utils/tokenHandler.util";
import { useLayoutEffect } from "react";

const LoggingInPage = () => {
  const { jwt } = useParams();
  // if jwt and encoded is null or undefined or empty string, redirect to login
  useLayoutEffect(() => {
    if (!jwt) {
      console.log("No jwt found");

      window.location.href = ROUTE_LOGIN_OUT;
      return;
    }

    // Use the jwt to request refresh and auth and set it in local storage
    const fetchData = async () => {
      await clearAllLocFor();
      console.log("fetching data");
      console.log(jwt);
      if (isTokenExpired(jwt) === false) {
        // console.log("jwt is not expired");
        const newJwt: JWT = {
          refreshToken: jwt,
        };
        // Request and Set the JWTs in local storage if the request was successful and is available
        await requestAndSetTokens(newJwt);

        // Once fetchMfaJWT is done and local storage is set, execute refreshTokenCheckRedirect
        refreshTokenCheckRedirect();
      } else {
        console.log("jwt is expired");
        window.location.href = ROUTE_LOGIN_OUT;
      }
    };
    fetchData();
  }, [jwt]);

  return (
    <div className="d-flex justify-content-center align-items-center flex-column text-2xl text-center mt-5">
      <CustomLoader />
      <div id="logging-in-banner" className="mt-3 font-bold text-primary">
        Logging in...
      </div>
    </div>
  );
};

export default LoggingInPage;
